module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-bingdao.067b61bd.mp4";